import { createContainer } from '@dbk-legacy/muster/react';
import SortingHeader from './sorting-header';
export default createContainer({
  $fragments: {
    uiStatic: {
      options: true,
    },

    state: {
      selectedKey: true,
      ascending: true,
      changeSort: { $call: 'changeSort' },
    },
}, 
}, ({ uiStatic, state }) => ({
  options: uiStatic.options,
  state: {
    selectedKey: state.selectedKey,
    ascending: state.ascending,
    onOptionSelect: state.changeSort,
  },
}))(SortingHeader);
